import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: '0.5rem',
    padding: '0.25rem',
    border: '0.0625rem solid #E0E0E0'
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    flexFlow: 'row',
    gap: '0.5rem',
    paddingBottom: '0.25rem',
    '& > svg': {
      cursor: 'pointer'
    }
  },
  searchRoot: {
    display: 'flex',
    alignItems: 'center',
    flexFlow: 'row',
    gap: '0.5rem',
    '& > svg': {
      cursor: 'pointer'
    }
  },
  selectField: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center'
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: '0.25rem',
    '& > svg': {
      cursor: 'pointer'
    }
  },
  field: {
    display: 'flex',
    gap: '0.25rem',
    flexFlow: 'column'
  },
  searchInputIcon: {
    zIndex: 1,
    marginLeft: 4,
    marginBottom: 4,
    position: 'absolute'
  },
  searchInput: {
    position: 'relative',
    paddingLeft: 24,
    paddingTop: 4,
    paddingBottom: 4,
    border: '1px solid #C6C6C6',
    borderRadius: '4px',
    boxSizing: 'border-box',
    width: '100%',
    fontSize: theme.size.sm,
    color: '#1F1F1F',
    background: '#F5F6F8',
    outline: 'none',

    '&::placeholder': {
      fontSize: theme.size.sm,
      color: '#8F8F8F'
    }
  },
  searchInputContainer: {
    display: 'flex',
    alignItems: 'center',
    flex: 1
  }
}))

export default useStyles
